export enum GemTreatment {
  None = 'None',
  Heating = 'Heating',
  HeatingAndPressure = 'Heating & Pressure',
  Oiling = 'Oiling',
  Enhancement = 'Enhancement',
  Composite = 'Composite',
  Dyeing = 'Dyeing',
  Waxing = 'Waxing',
  Coating = 'Coating',
  Diffusion = 'Diffusion',
  Filling = 'Filling',
  Imitation = 'Imitation',
  Bleaching = 'Bleaching',
  Irradiation = 'Irradiation',
  Impregnated = 'Impregnated',
  Lasering = 'Lasering',
  Other = 'Other',
}
